const FieldFocus = {
  directives: {
    focus: {
      inserted(el) {
        return el.focus()
      },
    },
  },
}

export default FieldFocus
